import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import './Blog.css'; // We'll create this file next


const posts = [
   {
    slug: 'rigend-film-case-study',
    title: 'How Rigend Film Turns K-Pop MVs into Cinematic Experiences',
    excerpt: 'Learn about the Seoul-based Production Powerhouse Rigend Film and the unique editing techniques they use to create captivating music videos.',
    date: 'September 21, 2025'},
  {
    slug: 'video-editing-workflow-tips',
    title: '3 Tips for a Smarter Video Editing Workflow',
    excerpt: 'By adopting a few key habits, you can relieve much of the heavy lifting, streamline your process, and focus more on the creative side of editing.',
    date: 'September 12, 2025'
  }
 

];


export default function Blog() {
  useEffect(() => {
    ReactPixel.track('ViewContent', { content_name: 'Blog Page' });
  }, []);
  return (
    <div className="blog-page-container">
      <div className="blog-header">
        <h1>Meaning in Motion</h1>
        <p>A Blog by Kaya: Insights on video editing, content creation, and productivity.</p>
      </div>
      <div className="blog-posts-list">
        {posts.map(post => (
          <div key={post.slug} className="post-preview-card">
            <div className="post-preview-content">
              <p className="post-preview-date">{post.date}</p>
              <h1 className="post-preview-title">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h1>
              <p className="post-preview-excerpt">{post.excerpt}</p>
              <Link to={`/blog/${post.slug}`} className="read-more-link">Read More →</Link>
            </div>
          </div>
          
        ))}
      </div>
    </div>
    
  
    
  );
}